import { create } from 'zustand';

interface UIState {
  developmentOpen: boolean;
  activeDevelopmentTab: string;
  leaderboardOpen: boolean;
  activityOpen: boolean;
  creaturePanelOpen: boolean;
  civilisationOpen: boolean;
  starMapOpen: boolean;
  eventLogOpen: boolean;
  techTreeOpen: boolean;
  openDevelopment: () => void;
  closeDevelopment: () => void;
  setActiveDevelopmentTab: (tab: string) => void;
  openLeaderboard: () => void;
  closeLeaderboard: () => void;
  openActivity: () => void;
  closeActivity: () => void;
  openCreaturePanel: () => void;
  closeCreaturePanel: () => void;
  openCivilisation: () => void;
  closeCivilisation: () => void;
  openStarMap: () => void;
  closeStarMap: () => void;
  openEventLog: () => void;
  closeEventLog: () => void;
  openTechTree: () => void;
  closeTechTree: () => void;
  closePanels: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  developmentOpen: false,
  activeDevelopmentTab: 'geology',
  leaderboardOpen: false,
  activityOpen: false,
  creaturePanelOpen: false,
  civilisationOpen: false,
  starMapOpen: false,
  eventLogOpen: false,
  techTreeOpen: false,
  openDevelopment: () => set({ developmentOpen: true }),
  closeDevelopment: () => set({ developmentOpen: false }),
  setActiveDevelopmentTab: (tab) => set({ activeDevelopmentTab: tab }),
  openLeaderboard: () => set({ leaderboardOpen: true }),
  closeLeaderboard: () => set({ leaderboardOpen: false }),
  openActivity: () => set({ activityOpen: true }),
  closeActivity: () => set({ activityOpen: false }),
  openCreaturePanel: () => set({ creaturePanelOpen: true }),
  closeCreaturePanel: () => set({ creaturePanelOpen: false }),
  openCivilisation: () => set({ civilisationOpen: true }),
  closeCivilisation: () => set({ civilisationOpen: false }),
  openStarMap: () => set({ starMapOpen: true }),
  closeStarMap: () => set({ starMapOpen: false }),
  openEventLog: () => set({ eventLogOpen: true }),
  closeEventLog: () => set({ eventLogOpen: false }),
  openTechTree: () => set({ techTreeOpen: true }),
  closeTechTree: () => set({ techTreeOpen: false }),
  closePanels: () => set({ developmentOpen: false, creaturePanelOpen: false, civilisationOpen: false, starMapOpen: false, techTreeOpen: false }),
}));
